import { render, staticRenderFns } from "./app-sidebar.html?vue&type=template&id=5370d472&scoped=true&external"
import script from "./app-sidebar.js?vue&type=script&lang=js&external"
export * from "./app-sidebar.js?vue&type=script&lang=js&external"
import style0 from "./app-sidebar.scss?vue&type=style&index=0&id=5370d472&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370d472",
  null
  
)

export default component.exports